module.exports = __webpack_public_path__ + "cloud-2.svg?8fac2e53c87656075d206d39b461f0cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloud-2.svg
// module id = 40
// module chunks = 0